var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateFolder = function SvgCreateFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "create-folder_svg__a",
    d: "M8.382 5H5v2h4.382l-1-2zM5 4h4l2 4H4V5a1 1 0 0 1 1-1zm0 4v11h15V8H5zM4 7h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm9 6h3v1h-3v3h-1v-3H9v-1h3v-3h1v3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "create-folder_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#create-folder_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#create-folder_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3899EC",
    mask: "url(#create-folder_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h22v22H1z"
  })))));
};
export default SvgCreateFolder;